<template>
  <RisksContentContainerWrapper
    v-if="ports && hasMaritimeAccess"
    class="pa-3 expand-left"
    wrapper-id="risks-ports"
    :reset-expanded="resetExpanded"
  >
    <v-card flat>
      <div class="hyp-risk-content-container">
        <div class="details-heading application-heading mb-4">
          Ports
          <v-select
            v-model="selectedPortCode"
            :items="ports"
            item-text="name"
            item-value="code"
            :width="200"
            class="pull-right pt-0 mr-2 port-types"
          ></v-select>
        </div>
        <v-row class="clearfix">
          <v-col cols="12" class="pt-0 content-container">
            <RiskRating
              v-if="selectedPortRating"
              :risk-rating="selectedPortRating"
            ></RiskRating>
          </v-col>
        </v-row>
        <v-row class="clearfix">
          <v-col cols="12" class="pt-0 content-container">
            <v-card
              v-if="selectedPortOverviewBody"
              flat
              outlined
              color="transparent"
              ref="portOverviewBody"
              v-html="selectedPortOverviewBody"
              class="mt-0 pt-0"
            >
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </RisksContentContainerWrapper>
</template>

<script>
import lodashFind from "lodash/find";
import { getRiskRatingsByCountryCode } from "@/services/controlRisks/risks.service";
import { hasMaritimeAccess } from "@/services/user/user.service";

export default {
  name: "RisksPorts",
  components: {
    RisksContentContainerWrapper: () =>
      import("@/components/controlRisks/risks/RisksContentContainerWrapper"),
    RiskRating: () => import("@/components/controlRisks/risks/RiskRating"),
  },
  props: {
    selectedLocation: {
      type: Object,
    },
    portsInfo: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      portsExpanded: false,
      resetExpanded: new Date().toISOString(),
      ports: null,
      selectedPortCode: null,
      portsRatings: null,
      hasMaritimeAccess: hasMaritimeAccess(),
    };
  },
  computed: {
    selectedPortOverviewBody() {
      if (this.ports && this.ports.length && this.selectedPortCode) {
        const port = lodashFind(this.ports, ["code", this.selectedPortCode]);
        return lodashFind(port?.overview, ["type", "overview"]).body;
      }
      return null;
    },
    selectedPortRating() {
      if (this.selectedPortCode && this.portsRatings) {
        return lodashFind(this.portsRatings, [
          "properties.code",
          this.selectedPortCode,
        ]).properties.ratings[0];
      }
      return null;
    },
  },
  watch: {
    portsInfo: {
      async handler() {
        if (this.portsInfo && this.portsInfo.length > 0) {
          this.ports = this.portsInfo;
          this.selectedPortCode = this.selectedLocation?.selectedPort?.code
            ? this.selectedLocation.selectedPort.code
            : this.ports[0]?.code;

          const { ports: portsRatings } = await getRiskRatingsByCountryCode(
            this.selectedLocation.iso2Code
          );
          if (
            portsRatings &&
            Array.isArray(portsRatings) &&
            portsRatings.length
          ) {
            this.portsRatings = portsRatings;
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.hyp-risks-content-expanded .hyp-risk-content-container {
  max-width: 50vw;
  margin: 12px auto;
}
</style>
